<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'SideMenuButton'
}
</script>

<style scoped>

</style>
